export default __webpack_public_path__ + "static/media/Mithril.ed95b5cd.png";